module.exports = __webpack_public_path__ + "static/media/bizminder.aa3b15df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bizminder.png
// module id = 642
// module chunks = 0